import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rows"]

import {ref, watch} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
  modelValue: {
    type: String
  },
  rows: {
    type: Number,
    default: 7
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const description = ref(props.modelValue);

watch(() => props.modelValue, (value) => {
  description.value = value;
});

watch(description, (newValue) => {
  emit('update:modelValue', newValue);
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    rows: __props.rows,
    class: "text-area-container",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event))
  }, null, 8, _hoisted_1)), [
    [_vModelText, description.value]
  ])
}
}

})